import { createAsyncThunk } from "@reduxjs/toolkit";
import { ax } from "../../../common/api/apiClient";
import { IApi } from "../../../common/typings/app";
import {
  IDashboard,
  IDashboardCargoBar,
  IDashboardLevel4Data,
  IDashboardRevenueBar,
  IDashboardVehicleBar,
  IDashboardVehicleComparison,
  IDashboardYardBar,
} from "../../../common/typings/hq-dashboard";
// As we are using createAsynThunk, so we are writing our actions separately to provide them in extraReducers

export const getAllTerminals = createAsyncThunk(
  "insights/getAllTerminals", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-terminals");
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getCargoAction = createAsyncThunk(
  "insights/getCargoAction", // action string
  async (data: IDashboard) => {
    try {
      const res = await ax.post<IApi>("/get-cargo-widget-hq", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getCargoBarChart = createAsyncThunk(
  "insights/getCargoBarChart", // action string
  async (data: IDashboardCargoBar) => {
    try {
      const res = await ax.post<IApi>("/get-consignment-type-by-cargo-type-widget", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getRevenueAction = createAsyncThunk(
  "insights/getRevenueAction", // action string
  async (data: IDashboard) => {
    try {
      const res = await ax.post<IApi>("/get-revenue-widget-hq", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getRevenueBarChart = createAsyncThunk(
  "insights/getRevenueBarChart", // action string
  async (data: IDashboardRevenueBar) => {
    try {
      const res = await ax.post<IApi>("/get-revenue-by-consignment-type-widget", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getYardAction = createAsyncThunk(
  "insights/getYardAction", // action string
  async (data: IDashboard) => {
    try {
      const res = await ax.post<IApi>("/get-yard-widget-hq", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getYardBarChart = createAsyncThunk(
  "insights/getYardBarChart", // action string
  async (data: IDashboardYardBar) => {
    try {
      const res = await ax.post<IApi>("/get-yard-aging-widget", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getVehicleAction = createAsyncThunk(
  "insights/getVehicleAction", // action string
  async (data: IDashboard) => {
    try {
      const res = await ax.post<IApi>("/get-vehicle-widget-hq", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getVehicleBarChart = createAsyncThunk(
  "insights/getVehicleBarChart", // action string
  async (data: IDashboardVehicleBar) => {
    try {
      const res = await ax.post<IApi>("/get-vehicle-type-by-consignment-type-widget", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getVehicleComparison = createAsyncThunk(
  "insights/getVehicleComparison", // action string
  async (data: IDashboardVehicleComparison) => {
    try {
      const res = await ax.post<IApi>("/get-vehicle-consignment-comparison-widget", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getVehicleLevel4TableData = createAsyncThunk(
  "insights/getVehicleLevel4TableData", // action string
  async (data: IDashboardLevel4Data) => {
    try {
      const res = await ax.post<IApi>("/get-vehicle-consignment-cargo-detail-list-widget", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getHQSettings = createAsyncThunk(
  "settings/getHQSettings", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("get_system_settings");
      if (res.data.isSuccess === true && res.data.value) {
        return res.data.value;
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const createHQSettings = createAsyncThunk(
  "settings/createHQSettings", // action string
  async (data: any) => {
    try {
      const res = await ax.post<IApi>("/create_system_settings", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateHQSettings = createAsyncThunk(
  "settings/updateHQSettings", // action string
  async (formRecord: any) => {
    try {
      const res = await ax.put<IApi>("/update_system_settings", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
